module.exports = __webpack_public_path__ + "img/a1.d2536d8a.png";